import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

const baseQueryWithAuth = fetchBaseQuery({
  baseUrl: !window.location.href.includes("test")
    ? process.env.REACT_APP_API_URL
    : "https://apitest.glassen-it.com/component/socparser/",
  prepareHeaders: (headers) => {
    const token = localStorage.getItem("access");

    if (token) {
      headers.set("Authorization", `Bearer ${token}`);
    }
    return headers;
  },
});

export const newsbreakApi = createApi({
  reducerPath: "newsbreak",
  baseQuery: baseQueryWithAuth,
  endpoints: ({ query }) => ({
    list: query({
      query: (body) => ({
        url: "inpd/getInpdList",
        method: "post",
        credentials: "include",
        body,
      }),
    }),
    item: query({
      query: (id: number) => ({
        url: "inpd/getInpd",
        method: "post",
        credentials: "include",
        body: { id },
      }),
    }),
  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
  useListQuery: useNewsbreakListQuery,
  useItemQuery: useNewsbreakItemQuery,
} = newsbreakApi;
